/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { type Corporation } from 'schema-dts'

import { useSiteMetadata } from '@/components/root-element'
import MicrodataDefault from '@/components/seo/microdata.default'
import MicrodataDialog from '@/components/seo/microdata.dialog'
import MicrodataEpisode from '@/components/seo/microdata.episode'
import MicrodataEvent from '@/components/seo/microdata.event'
import MicrodataInterview from '@/components/seo/microdata.interview'
import MicrodataPaper from '@/components/seo/microdata.paper'
import MicrodataPost from '@/components/seo/microdata.post'
import { getAbsoluteUrl } from '@/internal/utils/generate-url'
import { logo, publisherId } from '@/utils/microdata'

type MicrodataProps = {
  data: TemplateQueries
  location: {
    pathname: string
  }
}

export const Microdata: React.FC<MicrodataProps> = ({
  data,
  location: { pathname }
}) => {
  const { siteUrl } = useSiteMetadata()

  if (data == null) {
    return null
  }
  const url = getAbsoluteUrl(siteUrl, pathname)
  return (
    <>
      <MicrodataComponent data={data} url={url} />
      <JsonLd<Corporation>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Corporation',
          ...publisherId,
          name: 'NTT DATA',
          url: 'https://insurance.nttdata.com/',
          logo
        }}
      />
    </>
  )
}

type MicrodataComponentProps = {
  data: TemplateQueries
  url: string
}
const MicrodataComponent: React.FC<MicrodataComponentProps> = ({
  data,
  url
}) => {
  if (data === null) {
    return
  }
  if (data.__typename === 'DatoCmsPctPaper') {
    return <MicrodataPaper data={data} url={url} />
  }
  if (data.__typename === 'DatoCmsPctPost') {
    return <MicrodataPost data={data} url={url} />
  }
  if (data.__typename === 'DatoCmsPctInterview') {
    return <MicrodataInterview data={data} url={url} />
  }
  if (data.__typename === 'DatoCmsPctEpisode') {
    return <MicrodataEpisode data={data} url={url} />
  }
  if (data.__typename === 'DatoCmsPctEvent') {
    return <MicrodataEvent data={data} url={url} />
  }
  if (data.__typename === 'DatoCmsPctDialog') {
    return <MicrodataDialog data={data} url={url} />
  }

  return <MicrodataDefault data={data} url={url} />
}

export default Microdata
